import { dew as _ExtractTimezoneAbbrRefinerDew } from "./common/refiners/ExtractTimezoneAbbrRefiner";
import { dew as _ExtractTimezoneOffsetRefinerDew } from "./common/refiners/ExtractTimezoneOffsetRefiner";
import { dew as _OverlapRemovalRefinerDew } from "./common/refiners/OverlapRemovalRefiner";
import { dew as _ForwardDateRefinerDew } from "./common/refiners/ForwardDateRefiner";
import { dew as _UnlikelyFormatFilterDew } from "./common/refiners/UnlikelyFormatFilter";
import { dew as _ISOFormatParserDew } from "./common/parsers/ISOFormatParser";
import { dew as _MergeWeekdayComponentRefinerDew } from "./common/refiners/MergeWeekdayComponentRefiner";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.includeCommonConfiguration = void 0;
  const ExtractTimezoneAbbrRefiner_1 = __importDefault(_ExtractTimezoneAbbrRefinerDew());
  const ExtractTimezoneOffsetRefiner_1 = __importDefault(_ExtractTimezoneOffsetRefinerDew());
  const OverlapRemovalRefiner_1 = __importDefault(_OverlapRemovalRefinerDew());
  const ForwardDateRefiner_1 = __importDefault(_ForwardDateRefinerDew());
  const UnlikelyFormatFilter_1 = __importDefault(_UnlikelyFormatFilterDew());
  const ISOFormatParser_1 = __importDefault(_ISOFormatParserDew());
  const MergeWeekdayComponentRefiner_1 = __importDefault(_MergeWeekdayComponentRefinerDew());
  function includeCommonConfiguration(configuration, strictMode = false) {
    configuration.parsers.unshift(new ISOFormatParser_1.default());
    configuration.refiners.unshift(new MergeWeekdayComponentRefiner_1.default());
    configuration.refiners.unshift(new ExtractTimezoneAbbrRefiner_1.default());
    configuration.refiners.unshift(new ExtractTimezoneOffsetRefiner_1.default());
    configuration.refiners.unshift(new OverlapRemovalRefiner_1.default());
    configuration.refiners.push(new OverlapRemovalRefiner_1.default());
    configuration.refiners.push(new ForwardDateRefiner_1.default());
    configuration.refiners.push(new UnlikelyFormatFilter_1.default(strictMode));
    return configuration;
  }
  exports.includeCommonConfiguration = includeCommonConfiguration;
  //# sourceMappingURL=configurations.js.map
  return exports;
}